import React from 'react';
import { Formik, Form, Field } from 'formik';

import { useToast, GridItem, Grid, Heading, Box, Input, Select, Button } from '@chakra-ui/react';

import DatePicker from 'components/datePicker/DatePicker';

import { useParams } from 'react-router-dom';

import * as Yup from 'yup';

import xhr from 'xhr';

export default function InsertQuiz(props) {
  const { dataQuiz, setIsOpen4 } = props;
  const params = useParams();

  const toasts = useToast();
  const modalRef = React.useRef();

  const [dateFilter, setDateFilter] = React.useState(null);

  const [dateFilterEnd, setDateFilterEnd] = React.useState(null);

  const handleDateChange = (date) => {
    setDateFilter(date);
  };

  const handleDateChangeEnd = (date) => {
    setDateFilterEnd(date);
  };

  const [loadingButton, setLoadingButton] = React.useState(false);

  const handleQuiz = async (values, action) => {
    try {
      setLoadingButton(true);

      const response = await xhr.post(`/quizzes/`, {
        data: {
          ...values,
          module: params.idModule,
          enabled_date: dateFilter,
          enabled_date_end: dateFilterEnd,
        },
      });

      toasts({
        title: 'El quiz se creo correctamente!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      dataQuiz(response.data.data);

      setIsOpen4(false);

      action.resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };

  const RequerimentSchema = Yup.object().shape({
    title: Yup.string().required('Requerido'),
    duration: Yup.string().required('Requerido'),
  });

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          title: '',
          duration: '',
        }}
        validationSchema={RequerimentSchema}
        onSubmit={handleQuiz}
      >
        <Form>
          <Grid templateColumns="repeat(12, 1fr)" gap={6}>
            <GridItem colSpan={12}>
              <Box marginTop="20px">
                <Heading use="h3" width="100%">
                  Insertar Quiz
                </Heading>
              </Box>
              <Grid marginTop="20px" gap={4}>
                <GridItem colSpan={6}>
                  <Box>Título</Box>
                  <Field marginTop="20px" as={Input} name="title" />
                </GridItem>

                <GridItem colSpan={6}>
                  <Box>Duración</Box>
                  <Field marginTop="20px" as={Input} type="number" name="duration" />
                </GridItem>

                <GridItem colSpan={6}>
                  <Box color="#636363">Periodo</Box>
                  <Field marginTop="20px" name="period" as={Select}>
                    <option value=""></option>
                    <option value="primer">primer</option>
                    <option value="segundo">segundo</option>
                    <option value="tercero">tercer</option>
                    <option value="cuarto">cuarto</option>
                  </Field>
                </GridItem>

                <GridItem colSpan={12}>
                  <br />
                  <Box color="#636363">Fecha Inicio</Box>
                  <DatePicker date={dateFilter} placeholder="Fecha Inicio" onChange={handleDateChange} />
                  <br />
                  <Box color="#636363">Fecha Fin</Box>
                  <DatePicker date={dateFilterEnd} placeholder="Fecha Fin" onChange={handleDateChangeEnd} />

                  <br />
                </GridItem>
              </Grid>
            </GridItem>
          </Grid>

          <Button
            type="submit"
            colorScheme="#574feb"
            bg="#574feb"
            marginY="10px"
            marginX="10px"
            width="140px"
            isLoading={loadingButton}
            disabled={loadingButton}
          >
            Crear
          </Button>
        </Form>
      </Formik>
      <style jsx global>{`
        .rdw-editor-wrapper {
          min-height: 600px;
          border: 1px solid #d0cbcb;
        }
        .rdw-editor-main {
          padding: 10px;
        }
      `}</style>
    </div>
  );
}
